import PropTypes from 'prop-types';
import React from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader, Button } from 'reactstrap';
import SearchInput from '../../common/search/searchInput';
import Icon from '../../common/containers/icon';
const ReportTagsContainer = _ref => {
  let onSearchClear = _ref.onSearchClear,
    filters = _ref.filters,
    onSearch = _ref.onSearch,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 8
  }, /*#__PURE__*/React.createElement("h3", null, "Filter")), /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: onSearchClear,
    className: "float-md-right t-rtc-filter-clear"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "times-circle",
    weight: "far"
  }), " Clear")))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(SearchInput, {
    type: "text",
    text: filters.text,
    onChange: onSearch,
    onClear: onSearchClear
  })))), /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, children)));
};
ReportTagsContainer.propTypes = {
  children: PropTypes.node.isRequired,
  filters: PropTypes.shape({
    text: PropTypes.string
  }).isRequired,
  onSearch: PropTypes.func.isRequired,
  onSearchClear: PropTypes.func.isRequired
};
export default ReportTagsContainer;